import React from 'react';
import { Box, Button, Stack, Typography } from '@mui/material';
import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded';
import HomeRoundedIcon from '@mui/icons-material/HomeRounded';
import { useNavigate } from 'react-router-dom';

export default function PageHeader({
  title,
  subtitle,
  backTo,
  homeTo = '/',
  actionLabel,
  onAction,
  actionTo
}) {
  const navigate = useNavigate();

  const handleAction = () => {
    if (typeof onAction === 'function') {
      onAction();
      return;
    }
    if (actionTo) navigate(actionTo);
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', md: 'row' },
        alignItems: { xs: 'stretch', md: 'center' },
        justifyContent: 'space-between',
        gap: 2,
        mb: 3
      }}
    >
      <Box>
        <Stack direction="row" spacing={1} sx={{ mb: 1, flexWrap: 'wrap' }}>
          {backTo && (
            <Button
              variant="outlined"
              startIcon={<ArrowBackRoundedIcon />}
              onClick={() => navigate(backTo)}
              sx={{ minHeight: 44 }}
            >
              Retour
            </Button>
          )}
          <Button
            variant="text"
            startIcon={<HomeRoundedIcon />}
            onClick={() => navigate(homeTo)}
            sx={{ minHeight: 44 }}
          >
            Accueil
          </Button>
        </Stack>

        <Typography variant="h4" sx={{ fontWeight: 800, mb: 0.5 }}>
          {title}
        </Typography>
        {subtitle && (
          <Typography variant="body1" color="text.secondary">
            {subtitle}
          </Typography>
        )}
      </Box>

      {actionLabel && (onAction || actionTo) && (
        <Button
          variant="contained"
          onClick={handleAction}
          sx={{ minHeight: 48, px: 3, alignSelf: { xs: 'stretch', md: 'center' } }}
        >
          {actionLabel}
        </Button>
      )}
    </Box>
  );
}
